import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalXoa } from "./ModalXoa";

export const BtnXoa = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a className="dropdown-item" href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="Xoá"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img
            style={{ marginLeft: "5px" }}
            src="/app-assets/images/icon-xoa-v2.png"
          />
        </PopoversBootrap>
        <span
          class="vertical-align-v2"
          style={{ color: "#FF5170", marginLeft: "10px" }}
        >
          Xóa
        </span>
      </a>
      {show && (
        <ModalXoa
          show={show}
          onHide={handleClose}
          nhanvayId={item.ID}
          item={item}
        />
      )}
    </>
  );
};
